import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const classes = {
  singleSpeaker: {
    speakers: { top: 0, left: 0, right: 0, bottom: "80%" },
    screen: { top: "20%", left: 0, right: 0, bottom: 0 },
    arrows: { display: "none" },
  },
  multiSpeakersTop: {
    speakers: { top: 0, left: 0, right: 0, bottom: "80%" },
    screen: { top: "20%", left: 0, right: 0, bottom: 0 },
    arrows: { top: "1%", bottom: "81%" },
  },
  multiSpeakersBottom: {
    speakers: { bottom: 0, left: 0, right: 0, top: "80%" },
    screen: { bottom: "20%", left: 0, right: 0, top: 0 },
    arrows: { bottom: "1%", top: "81%" },
  },
  noSpeakers: {
    speakers: { display: "none" },
    screen: { top: 0, left: 0, right: 0, bottom: 0 },
    arrows: { display: "none" },
  },
  fullscreen: {
    speakers: { display: "none" },
    screen: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 90, height: "100%", width: "100%" },
    arrows: { display: "none" },
  },
};

export const screenshareLayouts = ["singleSpeaker", "multiSpeakersTop", "noSpeakers", "multiSpeakersBottom"];
export default function VonageScreenshare(props) {
  const [speakerCount, setSpeakerCount] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [speakerIndex, setSpeakerIndex] = useState(0);
  const [currentlyShown, setCurrentlyShown] = useState([]);
  const [maxCountToShow, setMaxCountToShow] = useState(5);
  const functionsRef = useRef();
  useEffect(() => {
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isFullscreen]);

  useEffect(() => {
    adjustCurrentlyShown();
  }, [props.screenshareLayout, props.currentSpotlights]);
  function adjustCurrentlyShown() {
    const { layoutMode, screenshareLayout, publisher, screensharePublisher, screenshareStream, streams, currentSpotlights } = props;
    const containerDiv = document.getElementById("vonage-screenshare-speakers");
    const hiddenDiv = document.getElementById("vonage-screenshare-hidden");
    if (layoutMode == "screenshare") {
      if (screenshareLayout == "singleSpeaker") {
        currentlyShown.length = 0;
        if (publisher) {
          if (screensharePublisher) {
            containerDiv.append(publisher.element);
            currentlyShown.push(publisher);
          } else hiddenDiv.append(publisher.element);
        }
        streams.forEach((s) => {
          hiddenDiv.append(s.element);
          if (typeof s.subscribeToVideo == "function") s.subscribeToVideo(false);
        });
        if (!screensharePublisher) {
          var speakerStream = streams.find((s) => s != null && s.stream && s.stream.name === screenshareStream?.stream?.name);
          if (speakerStream) {
            containerDiv.append(speakerStream.element);
            if (typeof speakerStream.subscribeToVideo == "function") speakerStream.subscribeToVideo(true);
            currentlyShown.push(speakerStream);
          }
        }
      } else if (screenshareLayout == "noSpeakers") {
        currentlyShown.length = 0;
        if (publisher) {
          hiddenDiv.append(publisher.element);
        }
        streams.forEach((s) => {
          hiddenDiv.append(s.element);
          if (typeof s.subscribeToVideo == "function") s.subscribeToVideo(false);
        });
      } else {
        if (publisher) {
          hiddenDiv.append(publisher.element);
        }
        streams.forEach((s) => {
          if (typeof s.subscribeToVideo == "function") s.subscribeToVideo(false);
          hiddenDiv.append(s.element);
        });
        if (currentSpotlights && currentSpotlights.length > 0) {
          if (publisher && currentSpotlights.includes(publisher.stream.name)) {
            containerDiv.append(publisher.element);
          }
          for (const subscriber of streams) {
            if (currentSpotlights.includes(subscriber.stream.name)) {
              if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
              containerDiv.append(subscriber.element);
            }
          }
        } else {
          for (const subscriber of currentlyShown) {
            if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
            containerDiv.append(subscriber.element);
          }
          if (currentlyShown.length < maxCountToShow) {
            while (currentlyShown.length < maxCountToShow) {
              if (hiddenDiv.firstChild) {
                if (props.publisher && props.publisher.element == hiddenDiv.firstChild) {
                  currentlyShown.push(props.publisher);
                  containerDiv.append(props.publisher.element);
                } else {
                  var newStream = props.streams.find((x) => x.element == hiddenDiv.firstChild);
                  if (newStream) {
                    currentlyShown.push(newStream);
                    if (typeof newStream.subscribeToVideo == "function") newStream.subscribeToVideo(true);
                    containerDiv.append(newStream.element);
                  }
                }
              } else {
                break;
              }
            }
          }
        }
      }
    }
  }
  function handleEsc(e) {
    if ((e.key == "Escape" || e.key == "Esc" || e.keyCode == 27) && isFullscreen) {
      e.preventDefault();
      toggleFullscreen();
      return false;
    }
  }
  useEffect(() => {
    props.setFunctionsRef(functionsRef);
  }, []);

  useEffect(() => {
    if(props.layoutMode !== "screenshare" && isFullscreen){
      setIsFullscreen(false);
    }
  },[props.layoutMode])
  useEffect(() => {
    const { streams, publisher } = props;
    let count = streams.length;
    if (publisher) count += 1;
    if (speakerCount != count) setSpeakerCount(count);
    functionsRef.current = {
      onStreamConnected,
      setNewPersonTalking,
      onStreamDisconnected,
      toggleScreenshareView,
    };
  });
  function scrollSpeakers(direction) {
    const { screenshareSpeakersRef } = props;
    if (screenshareSpeakersRef && screenshareSpeakersRef.children[0]) {
      const scrollTop = screenshareSpeakersRef.scrollTop;
      const scrollLeft = screenshareSpeakersRef.scrollLeft;
      const margin = screenshareSpeakersRef.children[0].getBoundingClientRect().height * 0.02;
      const childHeight = screenshareSpeakersRef.children[0].getBoundingClientRect().height + margin;
      const childWidth = screenshareSpeakersRef.children[0].getBoundingClientRect().width + margin;
      if (direction == "up") {
        screenshareSpeakersRef.style.transform = `translateY(${scrollTop - childHeight}px)`;
      }
      if (direction == "down") {
        screenshareSpeakersRef.style.transform = `translateY(${scrollTop + childHeight}px)`;
      }
      if (direction == "left") {
        if (speakerIndex > 1) {
          setSpeakerIndex(speakerIndex - 1);
          screenshareSpeakersRef.style.transform = `translateX(${(speakerIndex - 1) * (scrollLeft - childWidth)}px)`;
        } else if (speakerIndex == 1) {
          setSpeakerIndex(0);
          screenshareSpeakersRef.style.transform = `translateX(0px)`;
        }
      }
      if (direction == "right") {
        if (speakerIndex < speakerCount - 1) {
          screenshareSpeakersRef.style.transform = `translateX(${(speakerIndex == 0 ? 1 : speakerIndex + 1) * (scrollLeft - childWidth)}px)`;
          setSpeakerIndex(speakerIndex + 1);
        }
      }
    }
  }

  function toggleFullscreen() {
    if (isFullscreen == false) {
      props.toggleFullscreen(true);
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
      // props.toggleFullscreen(false)
    }
  }
  function toggleScreenshareView() {
    const hiddenDiv = document.getElementById("vonage-screenshare-hidden");
    props.streams.forEach((s) => {
      if (typeof s.subscribeToVideo == "function") s.subscribeToVideo(false);
      hiddenDiv.append(s.element);
    });
    adjustCurrentlyShown();
  }

  function onStreamConnected(subscriber) {
    if (currentlyShown.length < maxCountToShow) {
      currentlyShown.push(subscriber);
      if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
        if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
        const containerDiv = document.getElementById("vonage-screenshare-speakers");
        containerDiv.append(subscriber.element);
      }
    } else if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
      if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(false);
    }
  }
  function onStreamDisconnected(subscriber) {
    let subscriberToRemove = currentlyShown.find((s) => s.widgetId == subscriber.widgetId);
    if (subscriberToRemove) {
      const containerDiv = document.getElementById("vonage-screenshare-speakers");
      const hiddenDiv = document.getElementById("vonage-screenshare-hidden");
      currentlyShown.splice(currentlyShown.indexOf(subscriberToRemove), 1);
      if (hiddenDiv.firstChild) {
        if (props.publisher && props.publisher.element == hiddenDiv.firstChild) {
          currentlyShown.push(props.publisher);
          if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
            containerDiv.append(props.publisher.element);
          }
        } else {
          var newStream = props.streams.find((x) => x.element == hiddenDiv.firstChild);
          if (newStream) {
            currentlyShown.push(newStream);
            if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
              containerDiv.append(newStream.element);
            }
          }
        }
      }
    }
  }
  function setNewPersonTalking(subscriber) {
    const containerDiv = document.getElementById("vonage-screenshare-speakers");
    const hiddenDiv = document.getElementById("vonage-screenshare-hidden");
    if (currentlyShown.indexOf(subscriber) != -1 || props.screenshareLayout == "noSpeakers" || props.screenshareLayout == "singleSpeaker") {
      return;
    } else if (currentlyShown.length >= maxCountToShow) {
      currentlyShown.unshift(subscriber);
      let subToRemove = currentlyShown.pop();
      if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
        if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
        if (typeof subToRemove.subscribeToVideo == "function") subToRemove.subscribeToVideo(false);
        containerDiv.prepend(subscriber.element);
        hiddenDiv.prepend(subToRemove.element);
      }
    } else {
      currentlyShown.unshift(subscriber);
      if (props.layoutMode == "screenshare" && (props.screenshareLayout == "multiSpeakersTop" || props.screenshareLayout == "multiSpeakersBottom")) {
        containerDiv.prepend(subscriber.element);
        if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
      }
    }
  }
  return (
    <div id="vonage-screenshare-wrap" style={{ display: props.layoutMode == "screenshare" ? "block" : "none" }}>
      {speakerCount > 5 ? (
        <React.Fragment>
          <span
            className={"vonage-screenshare-streams-arrow" + (speakerIndex == 0 ? " disabled" : "")}
            id="vonage-screenshare-streams-arrow-left"
            style={classes[props.screenshareLayout].arrows}
            onClick={() => scrollSpeakers("left")}
          >
            <KeyboardArrowLeftIcon />
          </span>
          <span
            className={"vonage-screenshare-streams-arrow" + (speakerIndex == speakerCount - 1 ? " disabled" : "")}
            id="vonage-screenshare-streams-arrow-right"
            style={classes[props.screenshareLayout].arrows}
            onClick={() => scrollSpeakers("right")}
          >
            <KeyboardArrowRightIcon />
          </span>
        </React.Fragment>
      ) : null}
      <div
        ref={(r) => props.setScreenshareSpeakersRef(r)}
        id="vonage-screenshare-speakers"
        className={speakerCount < 5 || props.screenshareLayout == "singleSpeaker" ? "centered-flex no-transform" : ""}
        style={classes[isFullscreen ? "fullscreen" : props.screenshareLayout].speakers}
      ></div>
      <div
        ref={(r) => props.setScreenshareScreenRef(r)}
        id="vonage-screenshare-screen"
        className={isFullscreen ? "screenshare-fullscreen" : ""}
        style={classes[isFullscreen ? "fullscreen" : props.screenshareLayout].screen}
      >
      
      </div>
      <div ref={(r) => props.setScreenshareHiddenRef(r)} id="vonage-screenshare-hidden" style={{ display: "none" }}></div>
    </div>
  );
}
